import { Client, IMessage, StompSubscription, IFrame } from '@stomp/stompjs';
import SockJS from 'sockjs-client';

class StompService {
  private client: Client;
  private pendingSubscriptions: Array<{
    destination: string;
    callback: (message: IMessage) => void;
  }> = [];
  private isConnected = false;
  private activeSubscriptions: StompSubscription[] = [];

  constructor() {
    this.client = new Client({
      webSocketFactory: () => new SockJS('http://10.130.44.43:8080/r/api/chat'),
      reconnectDelay: 5000, // Auto reconnect in 5 seconds if the connection is lost
    });

    this.client.onConnect = this.onConnect;
    this.client.onStompError = this.onError;
    this.client.onDisconnect = this.onDisconnect;
  }

  private onConnect = () => {
    // eslint-disable-next-line no-console
    console.log('Connected to STOMP server');
    this.isConnected = true;

    // Subscribe to any pending subscriptions
    this.pendingSubscriptions.forEach((sub) => {
      const subscription = this.client.subscribe(sub.destination, sub.callback);
      this.activeSubscriptions.push(subscription);
    });
    // Clear the pending subscriptions
    this.pendingSubscriptions = [];
  };

  private onDisconnect = () => {
    // eslint-disable-next-line no-console
    console.log('Disconnected from STOMP server');
    this.isConnected = false;
    this.activeSubscriptions = [];
  };

  private onError = (frame: IFrame) => {
    // eslint-disable-next-line no-console
    console.error('Broker reported error:', frame.headers['message']);
    // eslint-disable-next-line no-console
    console.error('Additional details:', frame.body);
  };

  public activate() {
    this.client.activate();
  }

  public deactivate() {
    // Unsubscribe from active subscriptions
    this.activeSubscriptions.forEach((sub) => sub.unsubscribe());
    this.activeSubscriptions = [];
    this.client.deactivate();
    this.isConnected = false;
  }

  public subscribe(destination: string, callback: (message: IMessage) => void): StompSubscription {
    if (this.isConnected) {
      const subscription = this.client.subscribe(destination, callback);
      this.activeSubscriptions.push(subscription);
      return subscription;
    } else {
      // Not connected yet, store the subscription request
      this.pendingSubscriptions.push({ destination, callback });
      // Return a dummy subscription with an unsubscribe method
      return {
        unsubscribe: () => {
          // Remove from pending subscriptions
          this.pendingSubscriptions = this.pendingSubscriptions.filter(
            (sub) => sub.destination !== destination || sub.callback !== callback
          );
        },
      } as StompSubscription;
    }
  }
}

export default new StompService();
